import React, { useEffect } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { EnvelopeFill, Facebook } from "react-bootstrap-icons";
import AOS from "aos";
import "aos/dist/aos.css";
import "./AboutPage.css";

const AboutPage = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <Container fluid className="about-page-container">
      <div className="about-page-header">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8} className="text-center" data-aos="fade-up">
              <h1 className="about-title">Giới Thiệu</h1>
              <div className="title-divider"></div>
            </Col>
          </Row>
        </Container>
      </div>

      <Container className="about-page-content">
        <Row className="justify-content-center mb-5 align-items-center">
          <Col lg={7} data-aos="fade-up">
            <div className="about-text-container">
              <p className="about-description">
                <span className="text-highlight">Thinail</span> là nền tảng tiên phong trong việc giúp bạn đạt được chứng
                chỉ nail một cách dễ dàng và hiệu quả. Chúng tôi cung cấp hệ thống
                bài kiểm tra thực hành toàn diện, luôn sẵn sàng đồng hành cùng bạn
                trên hành trình chinh phục sự nghiệp.
              </p>
              <p className="about-description">
                Với Thinail, bạn không chỉ chuẩn bị cho kỳ thi, mà còn xây dựng nền tảng 
                vững chắc để thành công trong ngành nail chuyên nghiệp.
              </p>
              <div className="about-mission">
                <h3 className="mission-title">Sứ mệnh của chúng tôi</h3>
                <p className="mission-description">
                  Giúp mọi người chinh phục chứng chỉ nail California một cách hiệu quả, 
                  tiết kiệm thời gian và nâng cao tỷ lệ đỗ kỳ thi.
                </p>
              </div>
              <p className="about-contact-text">
                Nếu bạn có bất kỳ câu hỏi nào hoặc cần hỗ trợ, đừng ngần ngại liên
                hệ với chúng tôi qua <strong>email</strong> hoặc gửi tin nhắn qua{" "}
                <strong>Facebook</strong>. Đội ngũ hỗ trợ thân thiện và tận tâm của
                chúng tôi luôn sẵn sàng giúp bạn đạt được mục tiêu!
              </p>
            </div>
          </Col>

          <Col md={6} lg={5} data-aos="fade-left">
            <Card className="contact-card">
              <Card.Body>
                <div className="contact-card-header">
                  <h2 className="contact-title">Liên Hệ Với Chúng Tôi</h2>
                  <div className="contact-divider"></div>
                </div>
                
                <div className="contact-info">
                  <div className="contact-item">
                    <div className="icon-container">
                      <EnvelopeFill className="contact-icon" />
                    </div>
                    <div className="contact-details">
                      <h4>Email</h4>
                      <p>suport.thinail@gmail.com</p>
                    </div>
                  </div>
                  
                  <div className="contact-item">
                    <div className="icon-container">
                      <Facebook className="contact-icon" />
                    </div>
                    <div className="contact-details">
                      <h4>Facebook</h4>
                      <a
                        href="https://www.facebook.com/people/Thi-Nail/61569172920677"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="facebook-link"
                      >
                        Thinail Page
                      </a>
                    </div>
                  </div>
                </div>
                
                <div className="contact-cta">
                  <p>Chúng tôi luôn sẵn sàng hỗ trợ bạn 24/7</p>
                  <a 
                    href="mailto:suport.thinail@gmail.com" 
                    className="contact-btn"
                  >
                    Gửi Email Ngay
                  </a>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        
        <Row className="justify-content-center" data-aos="fade-up">
          <Col lg={10}>
            <div className="about-features">
              <h3 className="features-title">Tại Sao Chọn Thinail?</h3>
              <div className="features-divider"></div>
              
              <Row className="features-list">
                <Col md={4}>
                  <div className="feature-item">
                    <div className="feature-icon-container">
                      <span className="feature-icon">📚</span>
                    </div>
                    <h4>Nội Dung Chất Lượng</h4>
                    <p>Các câu hỏi và bài thi được cập nhật liên tục theo chuẩn PSI mới nhất.</p>
                  </div>
                </Col>
                
                <Col md={4}>
                  <div className="feature-item">
                    <div className="feature-icon-container">
                      <span className="feature-icon">🚀</span>
                    </div>
                    <h4>Học Mọi Lúc Mọi Nơi</h4>
                    <p>Truy cập từ bất kỳ thiết bị nào, bất cứ khi nào bạn có thời gian.</p>
                  </div>
                </Col>
                
                <Col md={4}>
                  <div className="feature-item">
                    <div className="feature-icon-container">
                      <span className="feature-icon">🏆</span>
                    </div>
                    <h4>Tỷ Lệ Đỗ Cao</h4>
                    <p>98% học viên đã vượt qua kỳ thi ngay từ lần đầu tiên với Thinail.</p>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default AboutPage;